const skipLinks = skipLinkElement => {

  // Element should exist.
  if (!skipLinkElement) {
    return;
  }

  skipLinkElement.addEventListener( 'keydown', event => {
    // Do nothing if the key isn't enter.
    if (event.key !== 'Enter') {
      return;
    }

    // There should be an anchor inside the element.
    if (!event.target.closest( 'a' )) {
      return;
    }

    event.preventDefault()

    const target = event.target.getAttribute( 'href' )
    const targetElement = document.querySelector( target )

    // Focus on the anchor's target if it exists.
    if (targetElement) {
      targetElement.setAttribute( 'tabindex', '-1' )
      targetElement.focus()
      return;
    }

    // Element was not found, let's go to h1 element instead.
    const h1Element = document.querySelector( 'h1' )

    // Focus on the h1 if it exists.
    if (h1Element) {
      h1Element.setAttribute( 'tabindex', '-1' )
      h1Element.focus()
      return;
    }

    console.warn( 'SkipLinks are not set, either missing a h1 or main content id on the page.' )
  } );
}
export default skipLinks;
